import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useMemo } from 'react';
import Colors from '~/constants/colors';
import { PATH } from '~/constants/enum';
import { ReviewItem } from '~/data/product/interfaces';
import useClient from '~/hooks/useClient';
import { getUrlCustom } from '~/utils/theme';
import Star from '../Star';
import Text from '../Text';

dayjs.extend(relativeTime);

type Props = {
    data: ReviewItem;
    url?: string;
};

const SliderItemReview = ({ data, url }: Props) => {
    const isClient = useClient();
    const { nickname, average_rating, text, created_at, images, product, summary } = data;

    const instance = useMemo(() => {
        if (!created_at) return '';
        return dayjs(created_at).fromNow();
    }, [data]);
    if (!isClient) return null;
    return (
        <div className="!flex md:justify-between h-full flex-col md:flex-row overflow-auto">
            <div
                className="bg-[#f8f8f8] flex-shrink-0 md:w-[480px] max-h-[540px] md:h-[auto] 
                          md:block flex justify-center items-center md:max-h-full"
            >
                <img src={url} alt="" className="h-full object-contain md:rounded-s-lg rounded-none" />
            </div>
            <div className="w-full py-2 px-[18px] h-full md:py-6 flex flex-col">
                <div className="flex flex-col flex-1">
                    <div
                        className={`flex items-center text-xs flex-wrap text-text-light gap-1 mt-1`}
                        style={{ color: Colors.GREY_10 }}
                    >
                        <span className={`font-semibold`}>{nickname}</span>
                        <span>|</span>
                        <div className={'flex items-center flex-nowrap'}>
                            <img src="/svgs/checked.svg" alt="Checked" width={16} height={16} />
                            <span className={`text-xs`}>Verified</span>
                        </div>
                    </div>
                    <div className="flex gap-2 items-center">
                        <span>
                            <Star size={16} value={(average_rating * 5) / 100} />
                        </span>
                        <span className={`text-xs`} style={{ color: Colors.GREY_10 }}>
                            {instance}
                        </span>
                    </div>
                    <div className="overflow-auto py-2 ">
                        <p className="text-sm">{text}</p>
                    </div>
                </div>
                {product && product.sku != 'REVIEW' && (
                    <div className="border border-gray-300 rounded-lg py-1 px-2 flex flex-col">
                        <Text type="body-3">Purchased product</Text>
                        <a
                            className="cursor-pointer transform duration-300
             hover:underline text-xs text-text-light inline-flex line-clamp-2"
                            href={getUrlCustom({
                                pathname: PATH.ProductDetail,
                                query: {
                                    slug: product.url_key,
                                    variant: product?.variants?.[0]?.product?.id
                                }
                            })}
                        >
                            <img
                                src={product.small_image?.url}
                                className="w-12 h-12 rounded mr-2 "
                                alt="product image"
                            />
                            {product.name}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SliderItemReview;
